import { h, Component } from 'preact';
import SignInLink from './SignInLink';
import SignInButton from './SignInButton';
import SignInModal from './SignInModal';
import SignInLinkHome from './SignInLinkHome';
import '../stylesheets/main.scss';

export default class SignIn extends Component {
  constructor () {
    super();

    this.state = {
      showModal: false,
      firstLoadingFinished: false,
    };

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate (prevProps) {
    const { isLoading: prevIsLoading } = prevProps;
    const { isLoading, insistLogin } = this.props;
    const { firstLoadingFinished } = this.state;

    if (firstLoadingFinished || !insistLogin) return;
    if (isLoading === prevIsLoading) return;

    // eslint-disable-next-line react/no-did-update-set-state
    if (!isLoading) this.setState({ firstLoadingFinished: true });

    this.setState({ showModal: true });
  }

  showModal () {
    const { mixpanelTracker } = this.props;
    mixpanelTracker.trackSignInClick(null);
    this.setState({ showModal: true });
  }

  closeModal () {
    this.setState({ showModal: false });
  }

  renderSignInVariant () {
    const {
      buttonText,
      invitationText,
      isLoading,
      modifierClass,
      variant,
    } = this.props;
    const variantProps = { isLoading, onClick: this.showModal };

    switch (variant) {
      case 'link':
        return <SignInLink {...variantProps} modifierClass={modifierClass} />;

      case 'button':
        return <SignInButton {...variantProps} buttonText={buttonText} invitationText={invitationText} />;

      case 'link-home':
        return <SignInLinkHome {...variantProps} />;

      default:
        return null;
    }
  }

  render ({ session, mixpanelTracker }) {
    const { showModal } = this.state;

    return (
      <div>
        {this.renderSignInVariant()}

        {showModal ? (
          <SignInModal
            onClose={this.closeModal}
            session={session}
            mixpanelTracker={mixpanelTracker}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SignIn.js